<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div class="chart-container">
  <div echarts [options]="chartOption()" class="chart"></div>
</div>
